import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SubscriptionFlowService } from '../services/subscription-flow.service';

export const subscriptionCompleteGuard: CanActivateFn = (route, state) => {
  const flow = inject(SubscriptionFlowService);
  const router = inject(Router);

  const canActivate: boolean = flow.isFlowActive() && !flow.isPendingActivation();

  return canActivate ? true : router.createUrlTree(['/subscription/upgrade']);
};
